/**
 * Resource → scopes mapping for token acquisition.
 *
 * Mirrors `environment.ts` `internalTenant.resourceMaps` from the legacy
 * Angular shell: when an outgoing request URL starts with one of these
 * prefixes, we ask MSAL for a token with the corresponding scopes.
 *
 * Scopes are provided per environment via build-time replacement
 * (`.env.production` `#{VITE_*}#` tokens → `.github/variables/*.yml`), mirroring
 * the legacy `environment.ts` `internalTenant` scopes: `portalInternalScope`
 * → `VITE_DEFAULT_SCOPE`, `rumInternalScope` → `VITE_RUM_INTERNAL_SCOPE`. The
 * RUM scope MUST stay env-specific — the RUM token service registers a
 * different resource id per environment (dev ≠ qa ≠ prod), so hardcoding one
 * env's id makes every other environment's RUM token 401.
 */
const DEFAULT_SCOPE = import.meta.env.VITE_DEFAULT_SCOPE;
const RUM_INTERNAL_SCOPE = import.meta.env.VITE_RUM_INTERNAL_SCOPE;

const RESOURCE_MAP: ReadonlyArray<readonly [string, readonly string[]]> = [
  [
    `${import.meta.env.VITE_RAPTOR_APIM_BASE_URL}${import.meta.env.VITE_TOKEN_SERVICE_PATH}/`,
    [RUM_INTERNAL_SCOPE],
  ],
  [
    `${import.meta.env.VITE_RAPTOR_APIM_BASE_URL}${import.meta.env.VITE_RUM_PATH}/`,
    [RUM_INTERNAL_SCOPE],
  ],
];

export function scopesForUrl(url: string): string[] {
  for (const [prefix, scopes] of RESOURCE_MAP) {
    if (url.startsWith(prefix)) return [...scopes];
  }
  return [DEFAULT_SCOPE];
}
